'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertDialog as AlertDialogPrimitive } from '@base-ui/react/alert-dialog';
import { cn } from 'cn';
import { Button } from '@/components/ui/button';
type AlertDialogProps = AlertDialogPrimitive.Root.Props;
export function AlertDialog(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <AlertDialogPrimitive.Root data-slot="alert-dialog" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type AlertDialogTriggerProps = AlertDialogPrimitive.Trigger.Props;
export function AlertDialogTrigger(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <AlertDialogPrimitive.Trigger data-slot="alert-dialog-trigger" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type AlertDialogPortalProps = AlertDialogPrimitive.Portal.Props;
export function AlertDialogPortal(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type AlertDialogOverlayProps = AlertDialogPrimitive.Backdrop.Props;
export function AlertDialogOverlay(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("fixed inset-0 isolate z-50 bg-black/80 duration-100", "supports-backdrop-filter:backdrop-blur-xs", "data-open:animate-in data-open:fade-in-0", "data-closed:animate-out data-closed:fade-out-0", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <AlertDialogPrimitive.Backdrop data-slot="alert-dialog-overlay" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogContentProps = {
  size?: 'default' | 'sm';
} & AlertDialogPrimitive.Popup.Props;
export function AlertDialogContent(props) {
  const $ = _c(11);
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      size: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const size = t0 === undefined ? "default" : t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AlertDialogOverlay />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== className) {
    t2 = cn("group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-1/2 gap-6 rounded-4xl bg-popover p-6 text-popover-foreground ring-1 ring-foreground/5 duration-100 outline-none", "data-[size=default]:max-w-xs", "data-[size=sm]:max-w-xs", "sm:data-[size=default]:max-w-md", "data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95", "data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t3 = <AlertDialogPortal>{t1}<AlertDialogPrimitive.Popup data-slot="alert-dialog-content" data-size={size} className={t2} {...rest} /></AlertDialogPortal>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
type AlertDialogHeaderProps = React.ComponentProps<'div'>;
export function AlertDialogHeader(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center", "has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-6", "sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left", "sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="alert-dialog-header" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogFooterProps = React.ComponentProps<'div'>;
export function AlertDialogFooter(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex flex-col-reverse gap-2", "group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2", "sm:flex-row sm:justify-end", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="alert-dialog-footer" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogMediaProps = React.ComponentProps<'div'>;
export function AlertDialogMedia(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("mb-2 inline-flex size-16 items-center justify-center rounded-full bg-muted", "sm:group-data-[size=default]/alert-dialog-content:row-span-2", "*:[svg:not([class*='size-'])]:size-8", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="alert-dialog-media" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogTitleProps = React.ComponentProps<typeof AlertDialogPrimitive.Title>;
export function AlertDialogTitle(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("font-heading text-lg font-medium", "sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <AlertDialogPrimitive.Title data-slot="alert-dialog-title" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogDescriptionProps = React.ComponentProps<typeof AlertDialogPrimitive.Description>;
export function AlertDialogDescription(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("text-sm text-balance text-muted-foreground", "md:text-pretty", "*:[a]:underline *:[a]:underline-offset-3", "*:[a]:hover:text-foreground", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <AlertDialogPrimitive.Description data-slot="alert-dialog-description" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogActionProps = React.ComponentProps<typeof Button>;
export function AlertDialogAction(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn(className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <Button data-slot="alert-dialog-action" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AlertDialogCancelProps = AlertDialogPrimitive.Close.Props & Pick<React.ComponentProps<typeof Button>, 'variant' | 'size'>;
export function AlertDialogCancel(props) {
  const $ = _c(14);
  let className;
  let rest;
  let t0;
  let t1;
  if ($[0] !== props) {
    ({
      className,
      variant: t0,
      size: t1,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
    t1 = $[4];
  }
  const variant = t0 === undefined ? "outline" : t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn(className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== size || $[8] !== variant) {
    t3 = <Button variant={variant} size={size} />;
    $[7] = size;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== rest || $[11] !== t2 || $[12] !== t3) {
    t4 = <AlertDialogPrimitive.Close data-slot="alert-dialog-cancel" className={t2} render={t3} {...rest} />;
    $[10] = rest;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}